<div class="redirect-container">
  <img src="../../../../assets/Partanalytics_logo_white.svg" alt="PartAnalytics">
  <span>Taking you to the Customer Application</span>
  <div class="loader-container">
      <div class='loader'>
          <div class='loader--dot'></div>
          <div class='loader--dot'></div>
          <div class='loader--dot'></div>
          <div class='loader--dot'></div>
      </div>
  </div>
</div>
